/*───────────────────────────────────────────────────────────────
 🌐 Project: Ring2All Platform
 🧑‍💻 Author: Rodrigo Cuadra
 🏢 Company: Ring2All LLC
 📄 File: utils/featureHelpers.ts (Feature Categories)
 🗓️ Created: 2025-01-27
 🧩 Description:
    Helper functions for Feature Code shuttle management.
────────────────────────────────────────────────────────────────*/

import { FeatureCode } from '../types';

/**
 * Filter available features (not selected)
 */
export function filterAvailableFeatures(
  features: FeatureCode[],
  selectedIds: Set<number>,
  searchQuery: string
): FeatureCode[] {
  const query = searchQuery.trim().toLowerCase();
  return features.filter((feature) => {
    if (selectedIds.has(feature.id)) {
      return false;
    }

    if (!query) {
      return true;
    }

    const haystack = [
      feature.name,
      feature.description,
      feature.defaultNumber,
      feature.customNumber,
    ]
      .filter(Boolean)
      .map((value) => value!.toLowerCase());

    return haystack.some((value) => value.includes(query));
  });
}

/**
 * Filter enabled features (selected)
 */
export function filterEnabledFeatures(
  features: FeatureCode[],
  selectedIds: Set<number>,
  searchQuery: string
): FeatureCode[] {
  const query = searchQuery.trim().toLowerCase();
  return features.filter((feature) => {
    if (!selectedIds.has(feature.id)) {
      return false;
    }

    if (!query) {
      return true;
    }

    const haystack = [
      feature.name,
      feature.description,
      feature.defaultNumber,
      feature.customNumber,
    ]
      .filter(Boolean)
      .map((value) => value!.toLowerCase());

    return haystack.some((value) => value.includes(query));
  });
}

